module.exports = {
          srcSet: __webpack_public_path__ + "public/1d348d8db5adba1baf94d9166e7860b6-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/1d348d8db5adba1baf94d9166e7860b6-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/1d348d8db5adba1baf94d9166e7860b6-80.png",
          toString:function(){return __webpack_public_path__ + "public/1d348d8db5adba1baf94d9166e7860b6-80.png"},
          
          width: 80,
          height: 80
        }